export enum SpellLevels {
    Focus = -1,
    Cantrip = 0,
    FirstLevel = 1,
    SecondLevel = 2,
    ThirdLevel = 3,
    FourthLevel = 4,
    FifthLevel = 5,
    SixthLevel = 6,
    SeventhLevel = 7,
    EighthLevel = 8,
    NinthLevel = 9,
    TenthLevel = 10,
}

export const MaxSpellLevel = 10;
